export default __webpack_public_path__ + "static/media/arrow.d3c750a2.svg";